'use client'

import dynamic from 'next/dynamic'

import LazyMount from '@/components/LazyMount'

const ChapterWhyWeBuild = dynamic(() => import('@/components/ChapterWhyWeBuild'), {
  ssr: false,
  loading: () => <div className="min-h-screen bg-[#060606]" />,
})

// The mission chapter pulls gsap (SplitText) + canvas art — below the fold,
// so its chunk loads on approach instead of during first-load hydration.
export default function ChapterWhyWeBuildLoader() {
  return (
    <LazyMount minHeight="100vh">
      <ChapterWhyWeBuild />
    </LazyMount>
  )
}
